module.exports = __webpack_public_path__ + "img/logo.11421292.png";